module.exports = __webpack_public_path__ + "img/about_office_3.212bc4ea.jpg";